import { ContentCardBanner } from "./ContentCardBanner";
import { ContentCardBody } from "./ContentCardBody";
import { ContentCardFooter } from "./ContentCardFooter";
import { ContentCardHeader } from "./ContentCardHeader";
import { ContentCardItem } from "./ContentCardItem";
import { ContentCardMain } from "./ContentCardMain";
import { ContentCardRoot } from "./ContentCardRoot";

export const ContentCard = {
  Root: ContentCardRoot,
  Banner: ContentCardBanner,
  Main: ContentCardMain,
  Header: ContentCardHeader,
  Body: ContentCardBody,
  Item: ContentCardItem,
  Footer: ContentCardFooter
};
